import { StackScreenProps } from '@react-navigation/stack'
import { ScreenWrapper } from '../../../@ui/containers/grid/screen.wrapper'
import { useGlobalStyles } from '../../../contexts/global-styles.provider'
import { Contribution } from '../../../generated/graphql'
import { useTheme } from '../../../hooks/theme.hook'
import { ReplayNavigatorParams } from '../../../navigation/types'
import { View } from 'react-native'
import { ContributionCard } from '../contributions/components/contribution.card'
import { useReplayApi } from '../../../services/snapshots/replay-api.hook'
import { useCallback, useEffect, useState } from 'react'
import { SecondaryTitleText } from '../../../@ui/typo/secondary-title.typo'
import { useTranslation } from 'react-i18next'
import Row from '../../../@ui/containers/grid/row'
import { IconButton } from 'react-native-paper'

const NoPerspectiveYet = () => {
  const { t } = useTranslation('replay')

  return <SecondaryTitleText title={t('contribution-not-found')} />
}
export function ReplayContributionScreen({
  route,
  navigation,
}: StackScreenProps<ReplayNavigatorParams, 'ReplayContribution'>) {
  const { contributionId } = route.params
  const theme = useTheme()
  const globalStyles = useGlobalStyles()
  const { contributionService, tick } = useReplayApi()

  const [contribution, setContribution] = useState<Contribution | null>(null)
  const refresh = useCallback(
    (contributionId: string) => {
      const contribution = contributionService.getContribution(contributionId)
      setContribution(contribution)
    },
    [contributionService]
  )

  useEffect(() => {
    refresh(contributionId)
  }, [tick, refresh, contributionId])

  return (
    <View style={globalStyles.pageContainer}>
      <ScreenWrapper>
        <Row alignItems="center" columnGap={4}>
          <IconButton
            mode={'outlined'}
            icon="arrow-left"
            onPress={() => navigation.goBack()}
          />
        </Row>
        <View style={{ marginHorizontal: theme.spacing(5) }}>
          {!contribution ? (
            <NoPerspectiveYet />
          ) : (
            <ContributionCard contribution={contribution} readonly={true} />
          )}
        </View>
      </ScreenWrapper>
    </View>
  )
}
export default ReplayContributionScreen
